import React, { useMemo, useState } from "react";
import { T } from "../../app/tokens.js";
import { createMarket } from "../../data/marketsClient.js";

// Mirrors MarketPlanPage's private generateMarketSlug so ids stay identical.
export function capacityMarketSlug(name, region) {
  const body = (name ?? "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 22);
  return body ? `${(region ?? "").toLowerCase()}-${body}` : "";
}

const field = { width: "100%", boxSizing: "border-box", fontSize: T.fsBase, border: `1px solid ${T.border}`, borderRadius: 7, padding: "8px 10px", fontFamily: "inherit", color: T.dark, background: T.card };
const lbl = { display: "block", fontSize: T.fsXs, fontWeight: T.fwSemibold, color: T.mid, marginBottom: 6 };

export function CapacityAddMarketDialog({ onClose, onCreated }) {
  const [name, setName] = useState("");
  const [region, setRegion] = useState("AMER");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const slug = useMemo(() => capacityMarketSlug(name, region), [name, region]);

  async function submit(e) {
    e.preventDefault();
    if (!name.trim()) { setError("Name is required."); return; }
    if (!slug) { setError("Name must contain at least one letter or digit."); return; }
    setBusy(true); setError(null);
    try {
      onCreated(await createMarket({ id: slug, name: name.trim(), region, status: "Active" }));
    } catch (err) {
      setError(err?.message ?? "Failed to create market.");
    } finally { setBusy(false); }
  }

  return (
    <div data-testid="capacity-add-market-modal" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: "fixed", inset: 0, background: T.modalOverlay, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9100 }}>
      <form role="dialog" aria-modal="true" aria-label="Add market" onSubmit={submit}
        style={{ background: T.card, borderRadius: 12, padding: "24px 28px", width: 400, maxWidth: "90vw", boxShadow: T.shadowFloat }}>
        <div style={{ fontWeight: T.fwBold, fontSize: T.fsMd, color: T.dark, marginBottom: 16 }}>Add market</div>
        <label htmlFor="cap-am-name" style={lbl}>Market name</label>
        <input id="cap-am-name" data-testid="capacity-add-market-name" value={name} onChange={(e) => setName(e.target.value)} style={field} autoFocus />
        {slug && <div style={{ marginTop: 4, fontSize: T.fsXxxs, color: T.light }}>ID: <code>{slug}</code></div>}
        <label htmlFor="cap-am-region" style={{ ...lbl, marginTop: 14 }}>Region</label>
        <select id="cap-am-region" value={region} onChange={(e) => setRegion(e.target.value)} style={field}>
          <option>AMER</option><option>EMEA</option><option>APAC</option>
        </select>
        {error && <div role="alert" style={{ marginTop: 12, fontSize: T.fsSm, color: T.ragRed }}>{error}</div>}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 }}>
          <button type="button" onClick={onClose} style={{ ...field, width: "auto", cursor: "pointer" }}>Cancel</button>
          <button type="submit" disabled={busy} data-testid="capacity-add-market-submit" style={{ ...field, width: "auto", cursor: "pointer", background: T.blue, color: T.card, border: 0, fontWeight: T.fwBold }}>{busy ? "Adding\u2026" : "Add market"}</button>
        </div>
      </form>
    </div>
  );
}
